import {DEFAULT_LOCALE} from 'src/internal/constants';

const defaultLocale = DEFAULT_LOCALE;

/**
 * A string with a BCP 47 language tag representing the locale
 * that is used by default by @sail/intl. As of today it is `en-US` and most likely will never change.
 *
 * This mostly indicates:
 *
 * - The fallback locale that will be used if the locale data for any other requested locale is missing.
 * - The language used to write localized messages in code.
 *
 * @see https://sail.stripe.me/apis/intl/defaultLocale
 */
export default defaultLocale;
